export default {
      id: "ar-portail-usage",
      viewBox: "0 0 125 125",
      url: "../dist/images/" + "sprite.svg#ar-portail-usage",
      toString: function () {
        return this.url;
      }
    }